"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalZipContainer = void 0;
const react_1 = __importDefault(require("react"));
const components_core_1 = require("@volkswagen-onehub/components-core");
const modal_layer_1 = require("../../modal-layer");
const styled_1 = require("./styled");
const ModalZipContainer = (props) => {
    const { active, children } = props;
    const ModalLayerWithFocusLock = (0, components_core_1.withFocusLock)(modal_layer_1.ModalLayer);
    return (react_1.default.createElement(components_core_1.LayerWrapper, null, active
        ? [
            react_1.default.createElement(components_core_1.ShimLayer, { key: "shim" }),
            react_1.default.createElement(ModalLayerWithFocusLock, { key: "Modal-layer", active: active, maxWidth: "1400px", hideCloseIcon: true, ariaLabel: "Zip Input Modal" },
                react_1.default.createElement(styled_1.StyledContainer, { className: "modal-zip__container" }, children)),
        ]
        : undefined));
};
exports.ModalZipContainer = ModalZipContainer;
